enum PositionEnum {
    left="left",
    right="right",
    center="center",
}

interface PropsI {
    className: string;
    position?: 'left'|'right'|'center';
    text: string;
    textStyle?: string;
}
const Divider = ({ className, position=PositionEnum.center, text, textStyle }: PropsI) => {
    return (
        <div className={`relative h-10 ${className}`}>
            <div className="w-full border-b border-grayscaleLine h-5"></div>
            <div
                className={`absolute bg-white px-5 top-1/2 -translate-y-1/2 
                    ${position === PositionEnum.center ? 'left-1/2 -translate-x-1/2' : '' }
                    ${position === PositionEnum.left ? 'left-0 ' : '' }
                    ${position === PositionEnum.right ? 'right-0 ' : '' }
                    ${textStyle}
                `}
            >
                { text }
            </div>
        </div>
    )
}
export default Divider;